import axios from 'axios';

class FileService {
  getStorageKey = () =>
    `oidc.user:${window.RUNTIME_CONFIG.KEYCLOAK_AUTHORITY}/${window.RUNTIME_CONFIG.KEYCLOAK_REALM}:${window.RUNTIME_CONFIG.KEYCLOAK_CLIENT}`;
  getBaseUrl = () => window.RUNTIME_CONFIG.FILE_SERVICE;
  getBaseUrlPresentationService = () => window.RUNTIME_CONFIG.PRESENTATION_SERVICE;
  async upload(
    file: File,
    clientSlug: string,
    type: 'logo' | 'banner' | 'banner-for-pdf',
    endpoint: string = 'upload'
  ) {
    const data = new FormData();
    data.append('file', file, `${clientSlug}-${type}.png`);

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${this.getBaseUrl()}/${clientSlug}/${endpoint}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async delete(clientSlug: string, type: 'logo' | 'banner' | 'banner-for-pdf') {
    const url = `${this.getBaseUrlPresentationService()}/files/delete`;
    const fileName = `${this.getBaseUrl()}/${clientSlug}/${clientSlug}-${type}.png`;

    const token = JSON.parse(sessionStorage.getItem(this.getStorageKey()) ?? '{}').access_token;

    await axios.post(
      url,
      { fileName },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
  }

  async uploadClientLogo(file: File, clientSlug: string, clientId: string) {
    const url = `${this.getBaseUrlPresentationService()}/files/logo`;
    const token = JSON.parse(sessionStorage.getItem(this.getStorageKey()) ?? '{}').access_token;

    const formData = new FormData();
    formData.append('file', file, `${clientSlug}`);

    await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Client-Id': clientId,
        Authorization: `Bearer ${token}`,
      },
    });
  }

  async uploadClientBanner(file: File, clientSlug: string, clientId: string) {
    const url = `${this.getBaseUrlPresentationService()}/files/banner`;
    const token = JSON.parse(sessionStorage.getItem(this.getStorageKey()) ?? '{}').access_token;

    const formData = new FormData();
    formData.append('file', file, `${clientSlug}`);

    await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Client-Id': clientId,
        Authorization: `Bearer ${token}`,
      },
    });
  }

  async uploadClientBannerForPdf(file: File, clientSlug: string, clientId: string) {
    const url = `${this.getBaseUrlPresentationService()}/files/banner-for-pdf`;
    const token = JSON.parse(sessionStorage.getItem(this.getStorageKey()) ?? '{}').access_token;

    const formData = new FormData();
    formData.append('file', file, `${clientSlug}`);

    await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Client-Id': clientId,
        Authorization: `Bearer ${token}`,
      },
    });
  }
}

export default new FileService();
